import moment, { Moment } from 'moment';

export function isValid24Hour(time: string): boolean {
    return moment(time, 'HH:mm', true).isValid();
}
export function toDateTimeFormat(time: Date | Moment) {
    return moment(time).format('YYYY-MM-DDTHH:mm:ss');
}

export function toDateFormat(date: Date | Moment | string) {
    return moment(date).format('YYYY-MM-DD');
}

/**
 * Combines a date string and a time string into a Moment object.
 * @param dateStr - date in "YYYY-MM-DD" or ISO format
 * @param timeStr - time in "HH:mm" 24-hour format
 * @returns Moment object representing the combined datetime, or null if invalid
 */
export function combineDateAndTime(dateStr: string, timeStr: string) {
    if (!moment(timeStr, 'HH:mm', true).isValid()) {
        return null;
    }

    const datePart = moment(dateStr).format('YYYY-MM-DD');

    const combined = moment(`${datePart} ${timeStr}`, 'YYYY-MM-DD HH:mm', true);

    return combined.isValid() ? combined : null;
}
